import { useKeycloak } from "@react-keycloak/web";
import NoLogin from "../pages/NoLogin";
import { hideCookieButton } from "./utils";
import { useEffect, useState } from "react";
import useAxios from "./useAxios";

const PrivateRoute = ({ children }) => {
    const { keycloak } = useKeycloak();
    const { fetch, data, error, loaded } = useAxios("", "", {}, true);

    const [company, setCompany] = useState(
        getSessionCompany()
    );

    function getSessionCompany() {
        const stored = sessionStorage.getItem('company');

        try {
            return JSON.parse(stored);
        }
        catch {
            return null;
        }
    }

    useEffect(() => {
        if (company === null && keycloak.authenticated) {
            fetch("POST", "/User/user-detail", {
                nif: keycloak.tokenParsed.preferred_username,
                email: keycloak.tokenParsed.email
            });

            const hasloggedHistory = sessionStorage.getItem('CreateLoginHistory');

            if (!hasloggedHistory || hasloggedHistory !== 'logged') {
                fetch("POST", "/User/create-login-history", { nif: keycloak.tokenParsed.preferred_username });
                sessionStorage.setItem('CreateLoginHistory', 'logged');
            }
        }
    }, [company]);

    // Process validation result
    useEffect(() => {
        if (loaded && error.length === 0) {
            if (data && data.companyName) {
                setCompany(data.companyName)
                sessionStorage.setItem('isValid', 'true');
                sessionStorage.setItem('company', data.companyName);
                sessionStorage.setItem('nifCompany', data.companyNif);
                sessionStorage.setItem('ADM', data.isAdmin);
            } else if (data && data.companyName == null && data !== true && data !== false) {
                sessionStorage.setItem('isValid', 'false');
                sessionStorage.removeItem('CreateLoginHistory');
                sessionStorage.removeItem('company');
                sessionStorage.removeItem('nifCompany');
                sessionStorage.removeItem('ADM');
                keycloak.logout();
            }
        }
    }, [data]);

    const authenticated = !!keycloak.authenticated


    // While validation is in progress, show loading spinner
    if (sessionStorage.getItem('isValid') === null) {
        return (
            <div className="d-flex justify-content-center align-items-center mt-5">
                <div className="spinner-border text-primary" role="status"></div>
            </div>
        );
    }

    if (sessionStorage.getItem('isValid') === 'false') {
        return <NoLogin showInvalid={true} />;
    }

    if (!authenticated) {

        if (sessionStorage.getItem('isValid') === 'true' && sessionStorage.getItem('CreateLoginHistory') === 'logged') {

            return (
                <div className="d-flex justify-content-center align-items-center mt-5">
                    <div className="spinner-border text-primary" role="status"></div>
                </div>
            );
        } else {
            return <NoLogin showInvalid={false} />;
        }
    }

    if (sessionStorage.getItem('isValid') === 'true' && authenticated) {
        hideCookieButton();
        return children;
    }
};

export default PrivateRoute;
